module.exports = __webpack_public_path__ + "assets/bf-uk.a488e3a7.svg";